import styled from 'styled-components'
import {darkGray} from '@modifi/colors'
import {media} from '@modifi/ui'

export const DialogHeadline = styled.div`
  font-weight: 600;
  color: ${darkGray};
  line-height: 1.25;
  font-size: 32px;
  text-align: center;

  ${media.max.sm`
    padding-right: 0
    padding-left: 0;
  `}
`

export const DialogDescription = styled.div`
  color: ${darkGray};
  text-align: center;
  line-height: 1.5;
`
